import React, { FC, ReactNode } from 'react'
import { ReactComponent as WarningTriangle } from '@sketch/icons/warning-triangle-64-svg'
import styled from 'styled-components'
import { Button, LinkButton, ErrorMessage } from '@sketch/components'
import { useVersioning } from 'modules/versioning'
import { useParams } from 'react-router'
import { RouteParams } from '@sketch/constants'

const StyledContainer = styled.div`
  flex: 1 0 auto;
  max-width: 500px;
  margin: auto;
`

const StyledActionsContainer = styled.div`
  display: flex;
`

const ReloadAction: FC = () => (
  <Button onClick={() => window.location.reload()} variant="secondary">
    Reload Canvas
  </Button>
)

const ViewAsArtboardsAction: FC = () => {
  const { getPathname } = useVersioning()

  const { shareID } = useParams<RouteParams<'SHARE_PAGE_CANVAS_VIEW'>>()

  const sharePageView = getPathname({
    routeKey: 'SHARE_VIEW_GRID',
    routeParams: { shareID },
  })

  return (
    <LinkButton to={sharePageView} variant="primary">
      View as Artboards
    </LinkButton>
  )
}

type PageCanvasErrorProps = {
  title?: string
  description: ReactNode
  showReloadCanvasAction?: boolean
  showViewAsArtboardsAction?: boolean
}

export const PageCanvasError: FC<PageCanvasErrorProps> = ({
  title = 'Couldn’t load canvas',
  description,
  showReloadCanvasAction,
  showViewAsArtboardsAction,
}) => {
  const actions: ReactNode[] = []

  if (showReloadCanvasAction) {
    actions.push(<ReloadAction key="reload" />)
  }

  if (showViewAsArtboardsAction) {
    actions.push(<ViewAsArtboardsAction key="view-artboards" />)
  }

  return (
    <StyledContainer>
      <ErrorMessage
        icon={<WarningTriangle />}
        iconSize="medium"
        title={title}
        description={description}
        extra={
          actions.length ? (
            <StyledActionsContainer>{actions}</StyledActionsContainer>
          ) : null
        }
      />
    </StyledContainer>
  )
}
